module.exports = __webpack_public_path__ + "img/mobile2.ece40655.svg";